import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import usePost from '../hooks/usePost';
import Error from './error';
import Loading from './loading';
import Header from './header';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export default function RegisterPage() {
  const classes = useStyles();

  const [registerForm, setRegisterForm] = useState({ email: '', password: '' });

  const [response, register] = usePost({
    path: 'main',
    payload: { btn: 'register', ...registerForm },
  });

  function onSubmit(event: any) {
    event.preventDefault();
    register();
  }

  return (
    <Container className={classes.container} maxWidth='xs'>
      <Header
        links={[
          { to: '/login', name: 'Login' },
        ]}
      />
      <form onSubmit={onSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Email'
                  name='email'
                  size='small'
                  variant='outlined'
                  defaultValue={registerForm.email}
                  onChange={(evt) =>
                    setRegisterForm({
                      ...registerForm,
                      email: evt.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label='Password'
                  name='password'
                  size='small'
                  type='password'
                  variant='outlined'
                  defaultValue={registerForm.password}
                  onChange={(evt) =>
                    setRegisterForm({
                      ...registerForm,
                      password: evt.target.value,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Button
              style={{ backgroundColor: '#1d4589', color: '#F79420' }}
              fullWidth
              type='submit'
              variant='contained'
            >
              Register
            </Button>
          </Grid>
        </Grid>
      </form>
      {!!response.error && <Error error={response.error} />}
      {!!response.message && (
        <div>
          <h2>{response.message}</h2>
        </div>
      )}
      <Loading loading={response.isLoading} />
    </Container>
  );
}
